import {FC, useState} from "react";
import {config} from "../../config";
import {Team, useApiCall} from "@jane/lib/src/api";
import {Input} from "@jane/lib/src/components/form/Input";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {TeamSelect} from "../../pages/documentationLibrary/DocumentationLibrarySpaceSettingsPage";

export const AddTeamSpaceModal: FC<{ teams: Team[], onFinished: () => void }> = (props) => {
  const { documentations } = useApiCall(config)
  const [name, setName] = useState<string>('')
  const [targetTeamId, setTargetTeamId] = useState<number|null>(null)
  const [selectedFile, setSelectedFile] = useState<File|null>(null)

  const save = async () => {
    if (targetTeamId === null) {
      return
    }

    await documentations.addTeamSpace(
      targetTeamId,
      name,
      selectedFile
    )
    props.onFinished()
  }


  return <div>
    <div className={'flex flex-col space-y-4 min-h-96'}>
      <Input maxWidth={'full'} type={'text'} label={'Naam'} value={name} onChange={setName} />
      <TeamSelect label={'Team'} teams={props.teams} value={targetTeamId} onChange={setTargetTeamId} />
    </div>

    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}